import type {ButtonProps} from '@primer/react'
import {Button} from '@primer/react'
import {useSlots} from '@primer/react/experimental'
import type React from 'react'
import {use} from 'react'

import styles from './Footer.module.css'
import {MarkdownEditorContext} from './MarkdownEditorContext'

export const CoreFooter = ({children}: {children: React.ReactNode}) => {
  const [slots, childrenWithoutSlots] = useSlots(children, {
    footerButtons: FooterButton,
  })

  return (
    <div className={styles.footer} data-testid="markdown-editor-footer">
      {slots.footerButtons && (
        <div className={styles.footerWrapper}>
          <div className={styles.footerButtonWrapper}>{slots.footerButtons}</div>
        </div>
      )}
      <div className={styles.childrenStyling}>{childrenWithoutSlots}</div>
    </div>
  )
}

export const Footer = ({children}: {children?: React.ReactNode}) => <CoreFooter>{children}</CoreFooter>
Footer.displayName = 'MarkdownEditor.Footer'

type FooterButtonProps = ButtonProps & {ref?: React.Ref<HTMLButtonElement>}

export const FooterButton = ({ref, ...props}: FooterButtonProps) => {
  const {disabled} = use(MarkdownEditorContext)
  return <Button size="small" disabled={disabled} {...props} ref={ref} />
}
FooterButton.displayName = 'MarkdownEditor.FooterButton'
